module.exports = {
  BREAD_PRICE: {
    SMALL: {
      value: 2500,
      name: "Roti Kecil",
    },
    BIG: {
      value: 5000,
      name: "Roti Besar",
    },
  },
  FLAVOUR_PRICE: {
    OREO: {
      big: 13500,
      small: 13500,
      name: "Oreo Cream Sweet",
    },
    RED_VELVET: {
      big: 13500,
      small: 13500,
      name: "Red Velvet Cream Sweet",
    },
    ASIN_ORI: {
      big: 16000,
      small: 16000,
      name: "Asin Original",
    },
    ASIN_ABON: {
      big: 18000,
      small: 18000,
      name: "Asin Abon",
    },
    ASIN_PEDAS: {
      big: 18000,
      small: 18000,
      name: "Asin Extra Pedas",
    },
    STRAWBERRY: {
      big: 20000,
      small: 10000,
      name: "Strawberry",
    },
    BLUEBERRY: {
      big: 16000,
      small: 10000,
      name: "Blueberry",
    },
    NANAS: {
      big: 16000,
      small: 10000,
      name: "Nanas",
    },
    TARO: {
      big: 20000,
      small: 10000,
      name: "Taro",
    },
    COKLAT: {
      big: 20000,
      small: 10000,
      name: "Coklat",
    },
    TIRAMISU: {
      big: 24000,
      small: 12000,
      name: "Tiramisu",
    },
    KEJU: {
      big: 22000,
      small: 12000,
      name: "Keju",
    },
    GREEN_TEA: {
      big: 24000,
      small: 12000,
      name: "Green Tea",
    },
    CHOCO_CRUNCHY: {
      big: 30000,
      small: 15000,
      name: "Choco Crunchy",
    },
    COKLAT_KEJU: {
      big: 26000,
      small: 14000,
      name: "Coklat Keju",
    },
    COKLAT_KACANG: {
      big: 24000,
      small: 12000,
      name: "Coklat Kacang",
    },
    KACANG: {
      big: 20000,
      small: 10000,
      name: "Kacang",
    },
    POLOS: {
      big: 7000,
      small: 7000,
      name: "Polos",
    },
    POLOS_BAKAR: {
      big: 10000,
      small: 10000,
      name: "Polos Bakar",
    },
  },
  INGREDIENTS: {
    MARGARIN: {
      price: 28000,
      qty: 0,
    },
    STRAWBERRY: {
      price: 32500,
      qty: 0,
    }, // per kg semua
    BLUEBERRY: {
      price: 22000,
      qty: 0,
    },
    NANAS: {
      price: 22000,
      qty: 0,
    },
    TARO: {
      price: 32500,
      qty: 0,
    },
    COKLAT: {
      price: 32500,
      qty: 0,
    },
    TIRAMISU: {
      price: 32500,
      qty: 0,
    },
    GREENTEA: {
      price: 36000,
      qty: 0,
    },
    CHOCO_CRUNCHY: {
      price: 43000,
      qty: 0,
    },
    KEJU: {
      price: 56000,
      qty: 0,
    },
    KACANG: {
      price: 35000,
      qty: 0,
    },
    SUSU_KENTAL: {
      price: 15000,
      qty: 0,
    }, // itungan kaleng
    KARDUS: {
      price: 90000,
      qty: 0,
    }, // per 100 biji
    PLASTIK: {
      price: 30000,
      qty: 0,
    }, // per kg
    LPG: {
      price: 18000,
      qty: 0,
    }, // 3 kg
    ROTI: {
      price: 5000,
      qty: 0,
    }, // per bh
  },
};
